/**
 * Padrões dos campos de cálculo da linha do orçamento: quantidade/diária vazias
 * valem 1; unitário, serviço e impostos vazios valem 0.
 *
 * Item 9 (rodada 2): chamado a cada recálculo da grade. Com os campos
 * CampoValor/CampoPercentual, o campo esvaziado NÃO manda '' ao pai enquanto está
 * focado, então o 0/1 só entra no blur (confirmação) e nunca aparece debaixo do
 * cursor — antes, apagar a diária e digitar 5 gravava 51.
 */
export function inicializarCamposCalculoSubitem(subitem = {}) {
    [
        'quantidadePreEvento',
        'diariaPreEvento',
        'quantidadeNegociado',
        'diariaNegociado',
        'quantidadeFechamento',
        'diariaFechamento',
    ].forEach((campo) => {
        if (subitem[campo] === undefined || subitem[campo] === null || subitem[campo] === '') {
            subitem[campo] = '1';
        }
    });

    [
        'valorUnitarioPreEvento',
        'valorUnitarioNegociado',
        'valorUnitarioFechamento',
        'servicoPreEvento',
        'servicoNegociado',
        'servicoFechamento',
        'impostoPorcentagemItem',
    ].forEach((campo) => {
        if (campo === 'impostoPorcentagemItem' && subitem.impostoNfAccessManualAgencia) return;
        if (subitem[campo] === undefined || subitem[campo] === null || subitem[campo] === '') {
            subitem[campo] = '0';
        }
    });

    if (subitem.inserirCalculoTotalPlanilha === undefined || subitem.inserirCalculoTotalPlanilha === null) {
        subitem.inserirCalculoTotalPlanilha = false;
    }
}
